module.exports = __webpack_public_path__ + "8ec5ed7141438c1c7d2c81fe63f7c74c.fbx";